module.exports = "/_next/static/images/tom-lubitz-3bf2935f00d1668349212936a8ecc09e.jpg";